<template>
     <router-view></router-view>
</template>

<script>
export default {
  name: 'Finance',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'финансы')
    })
  }
}
</script>
